var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert"},[_c('div',{staticClass:"alert__header"},[_c('h2',[_vm._v("ATTENTION:")]),_c('p',[_vm._v(" To View or Edit the pricing sheet for this project, please open on a desktop device ")])]),_c('div',{staticClass:"alert__body"},[_c('button',{staticClass:"btn btn--blue"},[_vm._v("Close")])])])
}]

export { render, staticRenderFns }